import { getProfileSaga, updateProfileSaga, updatePassword } from './profile';

export default [getProfileSaga, updateProfileSaga, updatePassword];
